export default __webpack_public_path__ + "static/media/hazhoz_boxes.24450115.png";